module.exports = __webpack_public_path__ + "img/bururito.e7d9492e.jpeg";